/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  guestIdentityImages: ModelRegistry['guest-identity-image'][];
}

export interface BookingIdentitySignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiBookingIdentityComponent = templateOnly<BookingIdentitySignature>();

export default UiBookingIdentityComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Identity': typeof UiBookingIdentityComponent;
  }
}
